import { RoomDifficulty } from 'src/common/enums/rooms';

import { ScoreTypeOption } from './room-settings-section.types';

export const ScoreType: { [key: number]: ScoreTypeOption } = {
  0: { id: '1', label: 'Points and first bloods', value: '0' },
  1: {
    id: '2',
    label: 'Points only (no first bloods)',
    value: '1',
  },
  3: {
    id: '4',
    label: 'Custom points',
    value: '3',
  },
  2: {
    id: '3',
    label: 'No points',
    value: '2',
  },
};

export enum ScoreTypeEnum {
  POINTS_AND_FIRST_BLOOD = 0,
  POINTS = 1,
  NO_POINTS = 2,
  CUSTOM_POINTS = 3,
}
const DIFFICULTY_RADIO_INPUT_NAME = 'difficulty';

export const DifficultyRadioInputs = [
  {
    id: RoomDifficulty.INFO,
    label: 'Info',
    name: DIFFICULTY_RADIO_INPUT_NAME,
    value: RoomDifficulty.INFO,
  },
  {
    id: RoomDifficulty.EASY,
    label: 'Easy',
    name: DIFFICULTY_RADIO_INPUT_NAME,
    value: RoomDifficulty.EASY,
  },
  {
    id: RoomDifficulty.MEDIUM,
    label: 'Medium',
    name: DIFFICULTY_RADIO_INPUT_NAME,
    value: RoomDifficulty.MEDIUM,
  },
  {
    id: RoomDifficulty.HARD,
    label: 'Hard',
    name: DIFFICULTY_RADIO_INPUT_NAME,
    value: RoomDifficulty.HARD,
  },
  {
    id: RoomDifficulty.INSANE,
    label: 'Insane',
    name: DIFFICULTY_RADIO_INPUT_NAME,
    value: RoomDifficulty.INSANE,
  },
];
